<template>
  <div>
    <div v-if="!blocks.length" class="tf-card">
      <div class="an-empty">
        <i class="fa fa-users"></i>
        <span>За период данных об аудитории нет</span>
      </div>
    </div>
    <section v-for="block in blocks" :key="block.key" class="tf-card">
      <div class="tf-card__head">
        <span class="tf-card__icon"><i class="fa" :class="block.icon"></i></span>
        <div class="tf-card__titles">
          <h3 class="tf-card__title">{{ block.title }}</h3>
        </div>
      </div>
      <div class="tf-card__body">
        <RumMetricsTable :rows="block.rows" :name-title="block.title" :rated="block.rated"/>
      </div>
    </section>
  </div>
</template>

<script>
import RumMetricsTable from "./RumMetricsTable.vue";
import {countryLabel} from "@/common/rumFormat";

// Сайт подписывает сегменты сам, а у разрезов по устройству и сети
// приходят только ключи. Подписи — те же, что в labels.ts на сайте.
const DEVICE_LABELS = {mobile: 'Телефоны', tablet: 'Планшеты', desktop: 'Компьютеры'}
const CONN_LABELS = {
  'slow-2g': 'Очень медленная (2G)',
  '2g': '2G',
  '3g': '3G',
  '4g': '4G и быстрее',
  unknown: 'Неизвестно (Safari, Firefox)',
}

/** Разрез сайта {key, metrics, views, bounces} → строка таблицы. */
function groupRows(groups, label) {
  const total = groups.reduce((sum, g) => sum + (g.views || 0), 0)

  return groups.map(g => ({
    key: g.key,
    label: label(g.key),
    views: g.views,
    share: total ? g.views / total : 0,
    bounceRate: g.views ? g.bounces / g.views : null,
    metrics: g.metrics,
    verdict: null,
  }))
}

export default {
  name: "RumAudience",
  components: {RumMetricsTable},
  props: {
    data: {type: Object, required: true},
  },
  computed: {
    blocks() {
      const blocks = []
      const add = (key, title, icon, groups, label) => {
        if (groups && groups.length) blocks.push({key, title, icon, rated: false, rows: groupRows(groups, label)})
      }
      add('devices', 'Устройства', 'fa-mobile', this.data.devices, k => DEVICE_LABELS[k] || k)
      add('connections', 'Связь', 'fa-signal', this.data.connections, k => CONN_LABELS[k] || k)
      add('countries', 'Страны', 'fa-globe', this.data.countries, countryLabel)

      const segments = this.data.segments || []
      segments.forEach(segment => {
        if (!segment.rows || !segment.rows.length) return
        blocks.push({
          key: 'seg-' + segment.seg,
          title: segment.name,
          icon: 'fa-pie-chart',
          rated: true,
          rows: segment.rows.map(row => ({...row, key: row.value})),
        })
      })

      return blocks
    },
  },
}
</script>
